import React, {Component} from 'react';
import {newsRSSRequest} from '../../../helpers/requests'
import RSSFeedList from '../features/homepage/RSSFeedList';
import ThemePageBanner from '../../dashboardNew/components/ThemePageBanner';
import { newsPageHelper } from '../../../helpers/prismicHelpers/prismic-custom-helpers/NewsHelper';
import { PrismicDocumentHelper } from '../../../helpers/prismicHelpers/PrismicHelpers';


class NewsPage extends Component {

    state = {
        news: '',
        rssArray: []
    }

    async componentDidMount() {
        const res = await newsRSSRequest();
        this.setState({rssArray: res});
        window.scrollTo(0, 0);
        this.getNewsInfoPrismic();
    }

    async getNewsInfoPrismic(){
    const data = await PrismicDocumentHelper('document.type', 'news-page', false, 'at');
    const news = newsPageHelper(data);
    this.setState({ news }) 
    }

    render() {

        const news = this.state.news[0];
        return (
            <React.Fragment>
                { news && 
                <ThemePageBanner
                    image='/images/news.jpg'
                    heading={news.news_title}/>}
                <div className="container theme-page-content-wrapper news-page">
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            { news && <p className='body-copy'>{news.news_summary}</p>}
                        </div>
                        <RSSFeedList rssArray={this.state.rssArray}/>
                    </div>
                </div>
                
            </React.Fragment>
        );
    }
}

export default NewsPage;


// WEBPACK FOOTER //
// src/client/components/site/pages/NewsPage.js